import { Draft } from '@reduxjs/toolkit';
import { ILiveSheetState } from './ILiveSheetState';

export function selectAllLayersReducer(state: Draft<ILiveSheetState>) {
  state.layers.forEach(($) => {
    $.isSelected = true;
  });
}
